import { Lead } from '../../../domain/entities/Lead';
import { ILeadRepository } from '../../../domain/repositories/ILeadRepository';
import { leadHistoryService } from '../../../services/leadHistoryService';
import { cancelFollowUpsForOpportunity } from '../../../services/modules/followUpService';

export interface LoseDealDTO {
    leadId: string;
    organizationId: string;
    lostReasonId: string; // ID do motivo de perda (obrigatório)
    comments?: string; // Comentários opcionais
}

export class LoseDealUseCase {
    constructor(private leadRepository: ILeadRepository) { }

    async execute(dto: LoseDealDTO): Promise<Lead> {
        // 1. Validar entrada
        if (!dto.lostReasonId || dto.lostReasonId.trim() === '') {
            throw new Error('Motivo de perda é obrigatório');
        }

        // 2. Buscar negociação
        const lead = await this.leadRepository.findById(dto.leadId);

        if (!lead) {
            throw new Error('Negociação não encontrada');
        }

        // 3. Validar se pode ser marcada como perdida
        if (!lead.isOpen()) {
            throw new Error(`Negociação já está ${lead.status === 'won' ? 'ganha' : 'perdida'}`);
        }

        // 4. Aplicar regra de negócio (domínio)
        lead.markAsLost(dto.lostReasonId, dto.comments);

        // 5. Persistir mudanças
        await this.leadRepository.save(lead, dto.organizationId);

        // 5.1. Cancela follow-ups agendados (negociação perdida não recebe mais mensagens automáticas)
        cancelFollowUpsForOpportunity(dto.leadId)
            .catch(err => console.warn('[LoseDealUseCase] Falha ao cancelar follow-ups (lost):', err?.name));

        console.log(`[LoseDealUseCase] Negociação ${lead.id} marcada como perdida. Motivo: ${dto.lostReasonId}`);

        // 6. Registrar no histórico
        leadHistoryService.addEvent({
            leadId: dto.leadId,
            organizationId: dto.organizationId,
            type: 'lost',
            description: 'Negociação marcada como perdida',
            newValue: dto.lostReasonId
        }).catch(err => console.warn('[LoseDealUseCase] Falha ao registrar histórico:', err));

        return lead;
    }
}
